import { toStatisticNumber } from 'utils/statisticNumber';
import { connect } from 'react-redux';
import React from 'react';
import { api } from 'app/services';
import { KBRangeDate } from 'components';
import * as selectors from 'app/selectors';
import { KBDropSelect } from 'components/plugins';
import dayjs from 'utils/dayjs';
import { InitialHighCharts } from 'components/mixins';
import { getYMD } from 'utils/kbUtil';
import { extendDefaultHighchartsConfig, getInitialDate } from 'utils/kbData';

var StatisticInvoiceAmountPrediction = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.parseLoadFromTo = this.parseLoadFromTo.bind(this);this._loadData = this._loadData.bind(this);this.parseJSON = this.parseJSON.bind(this);this.compare = this.compare.bind(this);this.fillChart = this.fillChart.bind(this);this._setFilters = this._setFilters.bind(this);this.changeDate = this.changeDate.bind(this);this.cycleChange = this.cycleChange.bind(this);this.selectCallBack = this.selectCallBack.bind(this);this.setMonthFilters = this.setMonthFilters.bind(this);}getInitialState()

  {
    const from = new Date();
    const to = dayjs().
    add(12, 'months').
    toDate();
    return {
      filters: {
        from,
        to,
        cycle: 'monthly' },

      data: [],
      month: '' };

  }componentDidMount()

  {
    const { filters, data } = this.state;
    let Highcharts = this.getHighcharts();
    let filtersMonths = dayjs(filters.to).diff(dayjs(filters.from), 'months');

    this.mounted = true;
    this.setState({
      month: filtersMonths });

    this._loadData(filters);
    this.renderChart(
    'Chart',
    extendDefaultHighchartsConfig({
      chart: {
        type: 'column' },

      title: {
        text: null },

      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          month: '%e. %b',
          year: '%b' },

        title: {
          text: '时间' },

        labels: {
          format: '{value:%Y-%m}' } },


      yAxis: {
        title: {
          text: '收款金额' },

        labels: {
          formatter: function () {
            return this.value;
          } } },


      tooltip: {
        headerFormat: '<b>{series.name}</b><br>',
        pointFormat: '日期：{point.x:%Y-%m}, 收款金额：{point.y}' },

      plotOptions: {
        spline: {
          marker: {
            enabled: true } } },



      series: data }));


  }componentWillUnmount()

  {
    this.mounted = false;
  }parseLoadFromTo(


  params, from, to) {
    delete params.from;
    delete params.to;

    params.start_date = from ? getInitialDate(from).initStartDateString : null;
    params.end_date = to ? getInitialDate(to).initEndDateString : null;

    return params;
  }_loadData(

  filters) {
    const { locations, formatStatisticToArray } = this.props;
    const { from, to, location_ids, cycle } = filters;
    var params = { location_ids, cycle };
    if (!location_ids && locations) {
      params.location_ids = locations.map(json => json.id).join(',');
    }

    // 判断日期
    params = this.parseLoadFromTo(params, from, to);

    api.getInvoiceStatisticByMonthlyDetail(params).then(({ json }) => {
      let data = formatStatisticToArray(json.total_amount || {}, 'month');
      let data_2 = formatStatisticToArray(json.paid_amount || {}, 'month');
      const paidAmountByDate = data_2.reduce((memo, d) => {
        memo[d.date] = d.value;
        return memo;
      }, {});
      data.map(d => {
        d.paid_amount = paidAmountByDate[d.date] || 0;
        return d;
      });
      this.parseJSON(data);
    });
  }parseJSON(

  json) {
    var contain = {};
    let data = [];

    if (!json || !Object.keys(json).length) {
      if (this.mounted) {
        this.setState({
          data });

      }
    }

    var array = json;
    var dt = { name: '应收款', data: [] };
    var dd = { name: '实收款', data: [] };

    array.forEach(json => {
      let { year, month, day } = getYMD(json.date);
      dt.data.push([Date.UTC(year, month), toStatisticNumber(json.value)]);
      dd.data.push([Date.UTC(year, month), toStatisticNumber(json.paid_amount)]);
    });

    dt.data.sort(this.compare);
    dd.data.sort(this.compare);

    data.push(dt);
    data.push(dd);
    this.fillChart(data);
  }compare(

  a, b) {
    if (!a || !b || !a[0] || !b[0]) {
      return 0;
    }

    if (a[0] - b[0] > 0) {
      return 1;
    } else if (a[0] - b[0] < 0) {
      return -1;
    }

    return 0;
  }fillChart(

  data) {
    this.setSerierDate(data);
  }_setFilters(

  obj) {
    let newFilters = Object.assign({}, this.state.filters, obj);
    this.setState({
      filters: newFilters });

    this._loadData(newFilters);
  }changeDate(

  range) {
    this._setFilters(range);
    this.setState({
      month: '' });

  }cycleChange(

  data) {
    this._setFilters({
      cycle: data });

  }selectCallBack(

  data) {
    this._setFilters({
      location_ids: data.map(json => json.id).join(',') });

  }setMonthFilters(

  num = 1) {
    var from = dayjs().toDate();
    var to = dayjs().
    add(num, 'months').
    toDate();

    this.setState({
      month: num });


    this._setFilters({
      from,
      to });

  }render()

  {
    const { locations } = this.props;
    const { filters, data, month } = this.state;
    const { from, to, cycle } = filters;
    return (
      <article>
        <div className="chart-title m-top-lg">
          <span>收款预测统计</span>
          <button className="bordered-btn-small" onClick={this.print}>
            <i className="iconfont icon-contract" />
            打印
          </button>
          <button className="bordered-btn-small" onClick={this.exportingExcel}>
            <i className="iconfont icon-EXCEL" />
            导出Excel
          </button>
        </div>
        <div className="m-bottom-sm">
          <KBRangeDate
          format="YYYY/MM/DD"
          from={from || ''}
          to={to || ''}
          callback={this.changeDate}
          leftNone={true} />

          <div className="time-filter">
            <button
            className={month == 1 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 1)}>

              1个月
            </button>
            <button
            className={month == 3 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 3)}>

              3个月
            </button>
            <button
            className={month == 6 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 6)}>

              6个月
            </button>
            <button
            className={month == 12 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 12)}>

              1年
            </button>
          </div>
          <KBDropSelect
          options={{ defaultSelectPrompt: '选择分店' }}
          defaultData={locations}
          multi={true}
          callback={this.selectCallBack}
          style={{ marginLeft: 20 }} />

        </div>
        <div ref={ref => { this.highcharts = ref; }} />
      </article>);

  }};Object.assign(StatisticInvoiceAmountPrediction.prototype, InitialHighCharts);


function mapStateToProps(state, props) {
  // const locations = selectors.getSerializeLocation(state)
  const { group_id } = props;
  const locations = selectors.getSerializeGroupsLocation(state, group_id);
  return {
    locations };

}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
mapStateToProps,
mapDispatchToProps)(
StatisticInvoiceAmountPrediction);
